import React from 'react';
import { CalendarDays } from 'lucide-react';
import { ClientType, RollingWindow } from '../../../types/common';
import { SegmentedControl } from '../../common';

interface ScopeBarProps {
  clientType: ClientType;
  rollingWindow: RollingWindow;
  periodLabel: string;
  onClientTypeChange: (t: ClientType) => void;
  onWindowChange: (w: RollingWindow) => void;
  disabled?: boolean;
}

export const ScopeBar: React.FC<ScopeBarProps> = ({
  clientType, rollingWindow, periodLabel,
  onClientTypeChange, onWindowChange, disabled,
}) => (
  <div className="flex flex-wrap items-center gap-3">
    <div className="flex items-center gap-2">
      <span className="text-xs font-semibold text-slate-500 uppercase tracking-wide">Segment</span>
      <SegmentedControl<ClientType>
        size="sm"
        value={clientType}
        onChange={onClientTypeChange}
        disabled={disabled}
        options={[
          { value: 'new', label: 'New' },
          { value: 'recurring', label: 'Recurring' },
          { value: 'both', label: 'Both' },
        ]}
      />
    </div>

    <div className="w-px h-5 bg-slate-200" />

    <div className="flex items-center gap-2">
      <span className="text-xs font-semibold text-slate-500 uppercase tracking-wide">Window</span>
      <SegmentedControl<RollingWindow>
        size="sm"
        value={rollingWindow}
        onChange={onWindowChange}
        disabled={disabled}
        options={[
          { value: 3, label: '3M' },
          { value: 6, label: '6M' },
          { value: 12, label: '12M' },
        ]}
      />
    </div>

    {periodLabel && (
      <>
        <div className="w-px h-5 bg-slate-200" />
        <div className="flex items-center gap-1.5 text-xs text-slate-500">
          <CalendarDays size={13} className="text-slate-600" />
          <span>{periodLabel}</span>
        </div>
      </>
    )}
  </div>
);

export default ScopeBar;
